// extracted by mini-css-extract-plugin
export default {"emailHighlight":"VerifyEmail_emailHighlight__O5-a7"};